export const description =
  "Remplacer une chaudière fioul ou gaz par une pompe à chaleur air/eau (COP ≥ 3,4) en cumulant MaPrimeRénov’ + Prime CEE + Coup de pouce + éco-PTZ + TVA 5,5 % 2026.";
